import { createBaseClient } from './base.client';
import { StandardApiResponse, ApiError } from '../types';
import { INSTANCE_URL } from '@config/env';

/**
 * Get base URL - use relative path in development for proxy, full URL in production
 */
const getAssistantBaseUrl = () => {
  if (import.meta.env.DEV) {
    return '/assistant'; // Use relative path for Vite proxy in development
  }
  return `${INSTANCE_URL}/assistant`;
};

/**
 * Assistant API Client
 */
const assistantAxios = createBaseClient(getAssistantBaseUrl(), 'Assistant');

/**
 * Assistant client function
 * @param endpoint - API endpoint path
 * @param method - HTTP method (defaults to GET)
 * @param data - Request payload (optional)
 * @param headers - Custom headers to merge with defaults (optional)
 * @returns Promise with StandardApiResponse (success only - errors are thrown)
 */
export const assistant = async <TData = any>(
  endpoint: string,
  method: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' = 'GET',
  data?: any,
  headers?: Record<string, string>
): Promise<StandardApiResponse<TData, ApiError | null>> => {
  const response = await assistantAxios.request<
    StandardApiResponse<TData, ApiError | null>
  >({
    url: endpoint,
    method,
    data,
    headers,
  });

  // Success only: errors are thrown by the interceptor as normalized Error objects
  // The success interceptor transforms AxiosResponse to StandardApiResponse
  // Type assertion is safe because the interceptor guarantees this shape
  return response as any as StandardApiResponse<TData, ApiError | null>;
};

export default assistant;
